<template>
    <div>
        <el-dialog :title="title" width="88%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close='hideDialog'>
            <el-form :inline="true" :model="filters" size="mini" style='text-align:left' :rules="dataRule">
                <el-form-item label="数据ID" v-if="dataIDFlag" prop="dataId">
                    <el-input
                        type="number"
                        style="width:140px"
                        v-model="exportDataId"
                        @mousewheel.native.prevent
                        placeholder="请输入数据ID"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="年份" v-if="dataYearFlag" prop="dataYear">
                    <el-select
                        multiple collapse-tags
                        style="width:140px"
                        @change="getCateList"
                        v-model="filters.dataYearArray"
                        placeholder="请选择数据年份"
                    >
                        <el-option
                        v-for="item in years"
                        :key="item"
                        :label="item"
                        :value="item"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省份" v-if="provinceFlag" prop="provinceId">
                    <el-select
                        style="width:140px"
                        v-model="filters.provinceId"
                        @change='getCityRecords'
                        placeholder="请选择省份">
                        <el-option
                            v-for="item in provinceList"
                            :key="item.provinceId"
                            :label="item.provinceShortName"
                            :value="item.provinceId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="院校所在省" v-if="schprovinceFlag" prop="schprovinceId">
                    <el-select
                        style="width:140px"
                        v-model="filters.schprovinceId"
                        placeholder="请选择省份">
                        <el-option
                            v-for="item in provinceList"
                            :key="item.provinceId"
                            :label="item.provinceShortName"
                            :value="item.provinceId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="统考类别" v-if="jonitFlag" prop="jointCategoryId">
                    <el-select
                    clearable
                    style="width:140px"
                    @change="getSearchList"
                    v-model="filters.jointCategoryId"
                    :placeholder="jointList.length>0?'请选择统考类别':'请选择年份省份'">
                        <el-option
                            v-for="item in jointList"
                            :key="item.jointCategoryId"
                            :label="item.jointCategoryName"
                            :value="item.jointCategoryId">
                        </el-option>
                    </el-select>
                    <!-- <el-select
                        remote
                        filterable
                        clearable
                        @clear = 'clearJoint'
                        @change="getSearchList"
                        :remote-method="getCateList"
                         v-model="filters.jointCategoryId"
                        placeholder="请输入统考类别"
                        style="width:140px">
                        <el-option
                            v-for="item in jointList"
                            :key="item.jointCategoryId"
                            :label="item.jointCategoryName"
                            :value="item.jointCategoryId">
                        </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="批次" prop="batch" v-if="batchFlag">
                    <el-select
                        clearable
                        v-model="filters.batch"
                        :placeholder="searchBatchList.length>0?'请选择批次':'请先选择年份、省份和统考类别'"
                        style="width:140px">
                        <el-option
                            v-for="item in searchBatchList"
                            :key="item.batch + 16"
                            :label="item.batchName"
                            :value="item.batch">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文理科别" v-if="aosFlag" prop="aos">
                    <el-select
                    style="width:140px"
                    clearable
                    v-model="filters.aos"
                    :placeholder="aosList.length>0?'请选择文理科别':'请选择年份省份'" >
                        <el-option
                            v-for="item in aosList"
                            :key="item.aos + 55"
                            :label="item.aosName"
                            :value="item.aos">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="城市" v-if="cityFlag" prop="cityId">
                    <el-select
                        style="width:140px"
                        v-model="filters.cityId"
                        :placeholder="cityList.length>0?'请选择城市':'请先选择省份'">
                        <el-option
                            v-for="item in cityList"
                            :key="item.cityId"
                            :label="item.cityName"
                            :value="item.cityId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考试大类" prop="examCategory" v-if="examCategoryFlag">
                    <el-select
                    v-model="filters.examCategoryId"
                    placeholder="请选择考试大类"
                    clearable
                    style="width:140px" >
                        <el-option
                            v-for="item in examcateList"
                            :key="item.typeId"
                            :label="item.typeName"
                            :value="item.typeId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="专业名称" prop="profName" v-if="profNameFlag">
                    <el-select
                        remote
                        filterable
                        clearable
                        :remote-method="getProfList"
                        v-model="filters.profName"
                        placeholder="请输入专业名称"
                        style="width:140px">
                        <el-option
                            v-for="item in profList"
                            :key="item.profId + 3"
                            :label="item.profName"
                            :value="item.profName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="高考报名人数" v-if="entranceExamNumFlag" prop="entranceExamNum">
                    <el-input style="width:140px" placeholder="请输入高考报名人数" v-model="filters.entranceExamNum"></el-input>
                </el-form-item>
                <el-form-item label="美术统考报名人数" v-if="artExamNumFlag" prop="artExamNum">
                    <el-input style="width:140px" placeholder="请输入美术统考报名人数" v-model="filters.artExamNum"></el-input>
                </el-form-item>
                <el-form-item label="考区名称" v-if="siteNameFlag" prop="siteName">
                    <el-input style="width:140px" placeholder="请输入考区名称" v-model="filters.siteName"></el-input>
                </el-form-item>
                <el-form-item label="排名类别" prop="categoryId" v-if="categoryFlag">
                    <el-select v-model="filters.categoryId" placeholder="请选择排名类别" style="width:140px">
                        <el-option
                            v-for="item in categoryList"
                            :key="item.categoryId + 4"
                            :label="item.categoryName"
                            :value="item.categoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="院校" v-if="schoolFlag">
                    <el-select
                        remote
                        filterable
                        clearable
                        :remote-method="getSchoolList"
                        v-model="filters.schoolId"
                        placeholder="请输入院校名称"
                        style="width:140px">
                        <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="成绩类型" prop="dataTypeString" v-if="dataTypeFlag">
                    <el-select clearable v-model="filters.dataTypeString" placeholder="请选择成绩类型" style="width:140px">
                        <el-option
                            v-for="item in typeList"
                            :key="item.value + 255"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" v-if="exportBartchFlag" prop="importBatch">
                    <!-- <el-input style="width:140px" placeholder="请输入导出批次" v-model="filters.importBatch"></el-input> -->
                    <el-select style="width:140px" v-model="filters.importBatch" placeholder="请选择备注">
                        <el-option
                            v-for="item in batchList"
                            :key="item+199"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="导出抬头类别" v-if="exportHeaderFlag" prop="exportHeaderType">
                    <el-select clearable style="width:140px" v-model="filters.exportHeaderType" placeholder="请选择抬头类别">
                        <el-option
                            v-for="item in headerList"
                            :key="item.value+201"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        icon="el-icon-download"
                        type="warning"
                        @click="exportExcel"
                    >
                        导出
                    </el-button>
                </el-form-item>
            </el-form>
                <perm-table
                :page="page"
                :columns="columns"
                :selectionChange="selectionChange"
                :handleCurrentHandle="handleCurrentHandle"
                :loading="loading"
                size="mini"
                :showEdit='true'
                :editLabel='editLabel'
                :showOperation='true'
                :showMore='true'
                permsEdit="sys:log"
                @findPage="getRecodes"
                @handleShoMore ='handleShoMore'
                @handleEdit='dlFile'>
            </perm-table>
        </el-dialog>
    </div>
</template>
<script>
import PermTable from '@/components/Component/PermTable/Index'
import PermButton from '@/components//Component/PermButton/Index'

export default {
    name: 'exportIndex',
    components: {
        PermTable,
        PermButton
    },
    props: {
        dataIDFlag: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '导出'
        },
        fileName: {
            type: Array,
            default: []
        },
        exportType: {
            type: Number,
            default: 1
        },
        provinceFlag: {
            type: Boolean,
            default: false
        },
        aosFlag: {
            type: Boolean,
            default: false
        },
        cityFlag: {
            type: Boolean,
            default: false
        },
        jonitFlag: {
            type: Boolean,
            default: false
        },
        dataYearFlag: {
            type: Boolean,
            default: false
        },
        entranceExamNumFlag: {
            type: Boolean,
            default: false
        },
        exportBartchFlag: {
            type: Boolean,
            default: false
        },
        exportHeaderFlag: {
            type: Boolean,
            default: false
        },
        artExamNumFlag: {
            type: Boolean,
            default: false
        },
        schoolFlag: {
            type: Boolean,
            default: false
        },
        profNameFlag: {
            type: Boolean,
            default: false
        },
        examCategoryFlag: {
            type: Boolean,
            default: false
        },
        isProvince: {
            type: Boolean,
            default: false
        },
        isXKInfo: {
            type: Boolean,
            default: false
        },
        isXKExamPlace: {
            type: Boolean,
            default: false
        },
        isTouDang: {
            type: Boolean,
            default: false
        },
        isZhaoLu: {
            type: Boolean,
            default: false
        },
        isLog: {
            type: Boolean,
            default: false
        },
        isProfRemark: {
            type: Boolean,
            default: false
        },
        isProfInfo: {
            type: Boolean,
            default: false
        },
        isOnLineSchool: {
            type: Boolean,
            default: false
        },
        isTxExamType: {
            type: Boolean,
            default: false
        },
        isProfPredict: {
            type: Boolean,
            default: false
        },
        isSchoolPredict: {
            type: Boolean,
            default: false
        },
        isSegment: {
            type: Boolean,
            default: false
        },
        isProvinceBatch: {
            type: Boolean,
            default: false
        },
        isProvinceBatchLine: {
            type: Boolean,
            default: false
        },
        isProvinceScoreLine: {
            type: Boolean,
            default: false
        },
        isJointCate: {
            type: Boolean,
            default: false
        },
        isSchoolRank: {
            type: Boolean,
            default: false
        },
        isProvJoint: {
            type: Boolean,
            default: false
        },
        tableId: {
            type: Number,
            default: 1
        },
        siteNameFlag: {
            type: Boolean,
            default: false
        },
        categoryFlag: {
            type: Boolean,
            default: false
        },
        dataTypeFlag: {
            type: Boolean,
            default: false
        },
        batchFlag: {
            type: Boolean,
            default: false
        },
        exportBatch: {
            type: Number,
            default: null
        },
        isProfLevel: {
            type: Boolean,
            default: false
        },
        schprovinceFlag: {
            type: Boolean,
            default: false
        },
        isProfexam: {
            type: Boolean,
            default: false
        },
        isEnrollformula: {
            type: Boolean,
            default: false
        },
        isSmallscorelimit: {
            type: Boolean,
            default: false
        },
        isSameprof: {
            type: Boolean,
            default: false
        },
        isWishPartners: {
            type: Boolean,
            default: false
        },
        isSchTxExamType: {
            type: Boolean,
            default: false
        },
        isAdmissionSchoolType: {
            type: Boolean,
            default: false
        },
        isUserInfoType: {
            type: Boolean,
            default: false
        },
        isCollectionSchoolType: {
            type: Boolean,
            default: false
        },
        isProvinceScheduleType: {
            type: Boolean,
            default: false
        },
        isExamScheduleType: {
            type: Boolean,
            default: false
        },
        isBatchScheduleType: {
            type: Boolean,
            default: false
        },
        isExceptions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            exportDataId: null,
            examcateList: [],
            filters: {
                dataYearArray: [],
                provinceId: null,
                schprovinceId: null,
                jointCategoryId: null,
                entranceExamNum: null,
                artExamNum: null,
                schoolId: null,
                cityId: null,
                siteName: null,
                aos: null,
                examCategoryId: null,
                profName: null,
                categoryId: null,
                dataTypeString: null,
                batch: null,
                importBatch: null,
                exportHeaderType: null
            },
            renderFlag: true,
            categoryList: [],
            dataRule: {
                // importBatch:[{required:true, message:'导出批次不能为空', trigger:'blur'}]
                // dataYear: [{ required: true, message: '数据年份不能为空', trigger: 'blur' }],
                // provinceId: [{ required: true, message: '省份id不能为空', trigger: 'blur' }],
                // jointCategoryId: [{ required: true, message: '统考类别不能为空', trigger: 'blur' }],
            },
            page: {},
            columns: [],
            schoolList: [],
            cityList: [],
            editLabel: '下载',
            loading: true,
            dialogVisible: true,
            pageRe: {
                current: 1,
                size: 5
            },
            searchjointCategory: {
                keywords: ''
            },
            aosList: [],
            searchSchool: {
                keywords: ''
            },
            provinceList: [],
            areaList: [],
            interVal: '',
            jointList: [],
            profList: [],
            searchBatchList: [],
            years: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
            typeList: [
                { name: '统考成绩', value: 1 },
                { name: '统考成绩（文科）', value: 2 },
                { name: '统考成绩（理科）', value: 3 },
                { name: '统考投档成绩', value: 4 },
                { name: '统考投档成绩（文科）', value: 5 },
                { name: '统考投档成绩（理科）', value: 6 },
                { name: '文化成绩', value: 7 },
                { name: '文化成绩（文科）', value: 8 },
                { name: '文化成绩（理科）', value: 9 }
            ],
            batchList: [],
            headerList: [
                { name: '计划数据(省份招生)', value: 1 },
                { name: '录取数据(院校录取)', value: 2 },
                { name: '志愿数据(志愿评估)', value: 3 },
                { name: '判断字段(概率判断)', value: 4 },
                { name: '录取数据(破格招生)', value: 5 }
            ]
        }
    },
    methods: {
        loadDataList() {
            this.$api.Provincetj.getProvincetjList(this.filters).then((res) => {
                this.page = res.data
                this.$forceUpdate()
            })
        },
        clearJoint() {
            this.filters.jointCategoryId = ''
        },
        // 获取考试大类列表
        getExamcateList() {
            const params = {
                typeFlag: 4
            }
            this.$api.prof.typeList(params).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                }
                this.examcateList = res.data
            })
        },
        // getCateList(params) {
        //     if (params !== '') {
        //         this.searchjointCategory.keywords = params
        //         this.$api.ZlInfo.getCateList(this.searchjointCategory).then(res => {
        //
        //             if (res && !res.success) {
        //                 this.$message({ message: res.message, type: 'error' })
        //                 return
        //             }
        //             this.jointList = res.data
        //         })
        //     }
        // },
        getNewYear() {
            if (this.filters.dataYearArray && this.filters.dataYearArray.length > 0 && this.filters.provinceId) {
                this.filters.dataYearArray.sort(function(a, b) {
                    return a - b
                })
                this.selectDataYear = this.filters.dataYearArray[this.filters.dataYearArray.length - 1]
            } else {
                this.selectDataYear = ''
                this.jointList = []
                this.filters.batch = ''
                this.filters.jointCategoryId = ''
            }
        },
        getCateList() {
            this.getNewYear()
            if (this.filters.provinceId) {
                this.jointList = []
                const params = {
                    dataYear: this.selectDataYear,
                    provinceId: this.filters.provinceId
                }
                this.$api.Tkinfo.getJointListByParam(params).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }

                    this.jointList = res.data
                    if (this.jointList.length > 0) {
                        this.filters.jointCategoryId = this.jointList[0].jointCategoryId
                    }
                    if (this.jointList.length == 0) {
                        this.filters.jointCategoryId = null
                    }
                    this.getSearchList()
                })
            }
            this.getAosList()
        },
        getAosList() {
            if (this.selectDataYear && this.filters.provinceId) {
                const data = {
                    dataYear: this.selectDataYear,
                    provinceId: this.filters.provinceId
                }
                this.$api.prof.getAosList(data).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.aosList = res.data
                    if (this.aosList.length == 0) {
                        this.filters.aos = null
                    }
                })
            }
        },
        getProfList(params) {
            console.log(params)
            const data = {
                keywords: params
            }
            console.log(data)
            this.$api.ProfRemark.searchProfList(data).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }

                this.profList = res.data
                return
            })
        },
        getSchoolList(params) {
            console.log(params)
            if (params !== '') {
                this.searchSchool.keywords = params
                this.$api.ZlInfo.getSchoolList(this.searchSchool).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.schoolList = res.data
                })
            }
        },
        getRecodes(dt) {
            // debugger
            var param = {
                bizTypeVal: this.exportType
            }
            if (dt) {
                Object.assign(param, dt.pageRequest)
                this.pageRe = dt
            }
            param.size = 5
            console.log(param)
            this.$api.base.getLogList(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }
                this.page = res.data
                if (!dt) {
                    this.hisL = res.data
                }
                this.loading = false
                if (!this.interVal) {
                    this.interVal = setInterval(() => {
                        // debugger
                        this.getRecodes(this.pageRe)
                    }, 2000)
                }
            })
        },
        exportExcel() {
            var callback = (res) => {
                if (!res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }
                this.$message({ message: '操作成功', type: 'success' })
            }
            var data = {
                tableId: this.tableId,
                title: this.title,
                fieldNames: this.fileName,
                dataYearArray: null,
                provinceId: null,
                schprovinceId: null,
                jointCategoryId: null,
                entranceExamNum: null,
                artExamNum: null,
                schoolId: null,
                cityId: null,
                profName: null,
                siteName: null,
                importBatch: null
            }
            data = Object.assign(data, this.filters)
            if (!this.jonitFlag && data.jointCategoryId) {
                delete data.jointCategoryId
            }
            if (this.isProvince) {
                data.dataId = this.exportDataId
                var module = 'Provincetj'
                var method = 'exportProvinceData'
            } else if (this.isXKInfo) {
                data.dataId = this.exportDataId
                module = 'Xkinfo'
                method = 'exportXKinfo'
            } else if (this.isXKExamPlace) {
                data.siteId = this.exportDataId
                module = 'Examplaceinfo'
                method = 'exportEPInfo'
            } else if (this.isTouDang) {
                data.dataId = this.exportDataId
                module = 'TDInfo'
                method = 'exportTData'
            } else if (this.isZhaoLu) {
                data.dataId = this.exportDataId
                module = 'ZlInfo'
                method = 'exportTData'
            } else if (this.isProfRemark) {
                data.remarkId = this.exportDataId
                module = 'ProfRemark'
                method = 'exportProfRemark'
            } else if (this.isProfInfo) {
                data.profId = this.exportDataId
                module = 'ProfInfo'
                method = 'exportProfInfo'
            } else if (this.isOnLineSchool) {
                data.siteId = this.exportDataId
                module = 'Onlinschool'
                method = 'exportOnLineSchool'
            } else if (this.isTxExamType) {
                data.dataId = this.exportDataId
                module = 'TxExamType'
                method = 'exportTxExamType'
            } else if (this.isProfPredict) {
                data.dataId = this.exportDataId
                module = 'ProfPredict'
                method = 'exportProfPredict'
            } else if (this.isSchoolPredict) {
                data.dataId = this.exportDataId
                module = 'SchoolPredict'
                method = 'exportSchoolPredict'
            } else if (this.isSegment) {
                data.segmentId = this.exportDataId
                module = 'SegmentTable'
                method = 'exportSegment'
            } else if (this.isProvinceBatch) {
                data.id = this.exportDataId
                module = 'ProvinceBatch'
                method = 'exportProvinceBatch'
            } else if (this.isProvinceBatchLine) {
                data.id = this.exportDataId
                module = 'ProvinceBatchLine'
                method = 'exportProvinceBatchLine'
            } else if (this.isProvinceScoreLine) {
                data.id = this.exportDataId
                module = 'ProvinceScoreLine'
                method = 'exportProvinceScore'
            } else if (this.isJointCate) {
                module = 'prof'
                method = 'exportJointCate'
            } else if (this.isSchoolRank) {
                data.rankId = this.exportDataId
                module = 'SchoolRank'
                method = 'exportSchoolRank'
            } else if (this.isProvJoint) {
                data.id = this.exportDataId
                module = 'prof'
                method = 'exportProvJointCategory'
            } else if (this.isProfLevel) {
                data.dataId = this.exportDataId
                module = 'ProfLevel'
                method = 'exportProfLevel'
            } else if (this.isProfexam) {
                data.dataId = this.exportDataId
                module = 'Profexamcategory'
                method = 'exportProfexam'
            } else if (this.isEnrollformula) {
                data.dataId = this.exportDataId
                module = 'Enrollformula'
                method = 'exportEnrollformula'
            } else if (this.isSmallscorelimit) {
                data.dataId = this.exportDataId
                module = 'Smallscorelimit'
                method = 'exportSmallscorelimit'
            } else if (this.isSameprof) {
                data.dataId = this.exportDataId
                module = 'Sameprof'
                method = 'exportSameprof'
            } else if (this.isWishPartners) {
                // data.dataId = this.exportDataId
                // module = 'Partners'
                // method = 'exportProvincePartners'
                this.$api.partners.exportWishPartners(data).then(res => {
                    callback(res)
                })
                return
            } else if (this.isSchTxExamType) {
                data.dataId = this.exportDataId
                module = 'TxExamType'
                method = 'exportSchTxExamType'
            } else if (this.isAdmissionSchoolType) {
                data.dataId = this.exportDataId
                module = 'SchoolType'
                method = 'exportSchoolType'
            } else if (this.isLog) {
                data.dataId = this.exportDataId
                module = 'ZlInfo'
                method = 'exportLog'
            }else if(this.isUserInfoType){
                data.dataId = this.exportDataId
                module = 'wishUser'
                method = 'exportUserInfo'
            } else if (this.isCollectionSchoolType) {
                data.dataId = this.exportDataId
                module = 'collectionschool'
                method = 'exportSchool'
            } else if (this.isProvinceScheduleType) {
                data.dataId = this.exportDataId
                module = 'schedule'
                method = 'exportProvinceSchedule'
            } else if (this.isExamScheduleType) {
                data.dataId = this.exportDataId
                module = 'schedule'
                method = 'exportExamSchedule'
            } else if (this.isBatchScheduleType) {
                data.dataId = this.exportDataId
                module = 'schedule'
                method = 'exportBatchSchedule'
            } else if (this.isExceptions) {
                data.dataId = this.exportDataId
                module = 'exceptions'
                method = 'exportExceptions'
            }
            console.log(JSON.stringify(data))
            this.$api[module][method](data).then(res => {
                callback(res)
            })
        },
        initColumns: function() {
            this.columns = [
                { prop: 'id', label: 'id', minWidth: 100 },
                { prop: 'bizType', label: '类型', minWidth: 100 },
                { prop: 'status', label: '状态', minWidth: 50 },
                { prop: 'progress', label: '进度', minWidth: 50, formatter: this.getProgress },
                { prop: 'createTime', label: '时间', minWidth: 100 }
            ]
        },
        getProgress(q, w, row) {
            w.renderCell = function(h, params) {
                if (params.row.status === '处理成功') {
                    return h('span', {

                    }, '100%')
                } else if (params.row.status === '处理中') {
                    // 超过三十分钟的任务，不再请求进度
                    var time = new Date().getTime()
                    if (time - Date.parse(params.row.createTime) > 30 * 60 * 1000) {
                        return
                    }
                    this.$api.base.getProgress({ id: params.row.id }).then(res => {
                        if (res && !res.success) {
                            this.$message({ message: res.message, type: 'error' })
                            return
                        }
                        console.log('res', res)
                        this.progressData = res.data + '%'
                    })
                    return h('span', {

                    }, this.progressData)
                }
            }
        },
        hideDialog() {
            this.$emit('hideDialog', this.filters)
            this.filters = {
                dataYearArray: null,
                provinceId: null,
                schprovinceFlag: null,
                jointCategoryId: null,
                entranceExamNum: null,
                artExamNum: null,
                schoolId: null,
                cityId: null,
                profName: null,
                siteName: null,
                importBatch: null
            }
        },
        selectionChange() {

        },
        getCityRecords(id) {
            this.getCateList()
            const data = {
                provinceId: this.filters.provinceId
            }
            this.$api.Examplaceinfo.getCityList(data).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }
                this.cityList = res.data
                console.log(this.cityList)
            })
        },
        handleCurrentHandle() {

        },
        dlFile(data) {
            if (data.row.status !== '处理成功') {
                this.$message({
                    message: data.row.logUrl || data.row.status,
                    type: 'warning'
                })
                return
            }
            const url = data.row.url
            window.open(url.replace('http:', 'https:'))
        },
        handleShoMore(par) {
            if (par.row.status == '处理成功') {
                this.$alert(par.row.status, '详情', {
                    confirmButtonText: '确定'
                })
            } else if (par.row.status == '处理中') {
                this.$alert(par.row.status, '详情', {
                    confirmButtonText: '确定'
                })
            } else {
                const data = { id: par.row.id }
                this.$api.keyWord.getLog(data).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.data, type: 'error' })
                        return
                    }
                    this.$alert(res.data, '详情', {
                        confirmButtonText: '确定'
                    })
                })
            }
        },
        getCategoryList() {
            const params = {
                current: 1,
                size: 100
            }
            this.$api.SchoolRank.searchCategoryList(params).then(res => {
                if (!res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }
                this.categoryList = res.data.records
            })
        },
        getSearchList() {
            this.searchBatchList = []
            this.filters.batch = null
            if (this.filters.provinceId && this.selectDataYear && this.filters.jointCategoryId) {
                const params = {
                    dataYear: this.selectDataYear,
                    provinceId: this.filters.provinceId,
                    jointCategoryId: this.filters.jointCategoryId
                }
                console.log(params)
                this.$api.ZlInfo.getBatchData(params).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }

                    this.searchBatchList = res.data
                    if (this.searchBatchList.length === 0) {
                        this.filters.batch = null
                    }
                })
            }
        },
        getBatchList() {
            var param = {
                bizType: this.exportBatch
            }
            this.$api.ImportBatch.getImportBatchList(param).then(res => {

                this.batchList = res.data
            })
        }
    },
    beforeDestroy() {
        clearInterval(this.interVal)
        this.interVal = ''
    },
    destroyed() {
        if (this.interVal) {
            clearInterval(this.interVal)
            this.interVal = ''
        }
    },
    mounted() {
        this.years.reverse()
        this.getBatchList()
        this.getExamcateList()
        this.provinceList = this.$store.state.baseProvinceList.provinceList
        this.getCategoryList()
        this.initColumns()
        this.getRecodes()
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Component/ExportProvinceData/provinceStatData.vue